import { jurisdictionCountyStateKeysFromStoredJson } from '@buxus/shared'
import { PROFILE_JURISDICTION_STORAGE_KEY } from '../abp/config'

/** Load persisted county–state keys written after `get-registration-profile`. */
export function loadProfileJurisdictionCountyStateKeys(): ReadonlySet<string> | null {
  try {
    const raw = localStorage.getItem(PROFILE_JURISDICTION_STORAGE_KEY)
    if (!raw?.trim()) return null
    const parsed = JSON.parse(raw) as unknown
    return jurisdictionCountyStateKeysFromStoredJson(parsed)
  } catch {
    return null
  }
}

export function clearProfileJurisdictionCountyStateKeys(): void {
  try {
    localStorage.removeItem(PROFILE_JURISDICTION_STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
